import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { RXGist, RXLine, RXOpt, RXOptGroup, RXTooth } from "src/app/shared/models/order.model";

@Component({
  selector: "rx-gist",
  templateUrl: "./rx-gist.component.html",
  styleUrls: ["./rx-gist.component.scss"],
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class RxGistComponent {
  @Input() rxGist: RXGist;

  get tableLines(): RXLine[] {
    return this.rxGist?.lines ?? [];
  }

  get implantTeeth(): RXTooth[] {
    return this.rxGist?.implantTeeth;
  }

  get attachments(): RXOptGroup {
    return this.rxGist?.rxOptions?.find((o) => o.optGroup == "IMP_ATTACH");
  }

  get attachmentsWithValues(): RXOpt[] {
    if (!this.attachments) {
      return [];
    }
    return this.attachments.options.filter((opt) => this.hasOptValue(opt));
  }

  hasOptValue(opt: RXOpt): boolean {
    return !!(
      opt.selectedValue ||
      opt.valueText ||
      opt.valueNum != null ||
      opt.valueBool != null
    );
  }

  getOptDisplayValue(opt: RXOpt): string {
    if (opt.selectedValue) {
      return opt.selectedValue.text;
    } else if (opt.valueText) {
      return opt.valueText;
    } else if (opt.valueNum != null) {
      return opt.valueNum.toString();
    } else if (opt.valueBool != null) {
      return opt.valueBool ? "true" : "false";
    }
    return "";
  }
}

